module.exports = __webpack_public_path__ + "static/img/presta-shop.fb1685c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/presta-shop.png
// module id = b1yn
// module chunks = 0 139